window.WS = {
    layers: {
        no_connected_btn: $('.server-no-connected-btn')
    },

    reconnectTimerID: false,
    reconnectCount: 0,
    auth: false,

    ID: {
        getMapChargers: "111",
        search: "111",
        getChargerInfo: "111",
        loginPart1: "111",
        loginPassword: "111",
        forgot_password: "111",
        login_one_password: "111",
        login_new_account_password: "111",
        general_info: "111",
        change_password: "111",
        auth_edit: "111",
        full_transactions_history: "111",
        transaction_subscribe: "111",
        transaction_unsubscribe: "111",
        skip_min_balance: "111",
        auth_delete: "111",
        start_transaction: "111",
        stop_transaction: "111",
        book_connector_tariff: "111",
        book_connector: "111",
        add_comment: "111",
        add_review: "111",
        logout: "111",
        delete_bank_card: "111",
        default_bank_card: "111",
    },

    socket: $.simpleWebSocket({
            url: window.ws_link,
            timeout: 5000,
            attempts: 30,
            dataType: 'json',
            onOpen: async (event) => {
                window.WS.wsOpen(event);
            },
        onClose: async (event) => {
            window.WS.wsClose(event);
        },
        onError: async (event) => {
            var data = JSON.stringify({
                "url": window.location.href,
                "client": window.user_pk,
                "data": event
            });

            data = btoa(encodeURI(encodeURIComponent(data)));
            /*window.LOG.send_data(data);*/
        },
    }).listen(async (data) => {
        window.WS.message(data);
    }),

    init: async () => {
        window.WS.socket.connect();
    },

    message: async (data) => {
        data = atob(data.data);
        data = JSON.parse(data);

        /*console.log(data);*/

        switch (data[1]) {
            case window.WS.ID.delete_bank_card:
                if(typeof data[2] != 'undefined' && typeof data[2].status != 'undefined' && typeof data[2].pk != 'undefined' && data[2].status == 'success') {
                    $('#screens .screen.settings .bank-cards .card-list .card[data-id='+ data[2].pk +']').hide();
                    window.NOTIFFICATIONS.open_bank_card_delete_success();
                }
            break;
            case window.WS.ID.default_bank_card:
                if(typeof data[2] != 'undefined' && typeof data[2].status != 'undefined' && data[2].status == 'success') {
                    window.NOTIFFICATIONS.open_default_bank_card();
                }
            break;
            case window.WS.ID.getChargerInfo:
                window.CHARGER.show_info(data[2]);
            break;
            case window.WS.ID.getMapChargers:
                if(typeof window.GMAP.parseGmapMarkers != 'undefined') {
                    window.GMAP.parseGmapMarkers(data[2]);
                }
            break;
            case window.WS.ID.search:
                window.SEARCH.search_results(data[2]);
            break;
            case window.WS.ID.loginPart1:

                if(data[2].is_block == true) {

                    window.LOGIN.layers.cross.click();
                    window.NOTIFFICATIONS.open_user_bunned();

                } else if(data[2].is_new == true) {

                    window.LOGIN.showNewForm();
                    window.LOGIN.openCodeform();

                } else {

                    window.LOGIN.showLoginForm();
                    window.LOGIN.openCodeform();

                }

                window.LOGIN.layers.login_new_user_key.val(data[2].key);
                window.LOGIN.layers.phone_form_submit.prop('disabled', false);
            break;
            case window.WS.ID.loginPassword:

                if(data[2].status) {

                    var auth = btoa(encodeURI(encodeURIComponent(data[2].auth)));
                    $.cookie('auth', auth, { expires: 365, path: '/', domain: window.domain_in, secure: true });
                    /*location.reload();*/
                    window.location.href=data[2].url;

                } else {
                    window.NOTIFFICATIONS.open_wrong_password();
                    window.LOGIN.layers.login_code_password.val('');
                    window.LOGIN.layers.login_btn.prop('disabled', true);
                }

                window.LOGIN.layers.phone_form_submit.prop('disabled', false);
            break;
            case window.WS.ID.login_one_password:
                if(data[2].status) {

                    /*var auth = btoa(encodeURI(encodeURIComponent(data[2].auth)));
                    $.cookie('auth', auth, { expires: 365, path: '/', domain: window.domain_in, secure: true });
                    /!*location.reload();*!/
                    window.location.href=data[2].url;*/

                    window.NOTIFFICATIONS.open_recovery_emailsuccess();
                    setTimeout(function() {
                        location.reload();
                    }, 3000);

                } else {
                    window.NOTIFFICATIONS.open_wrong_password();
                    window.LOGIN.layers.one_password.submit_btn.prop('disabled', true);
                }
            break;
            case window.WS.ID.login_new_account_password:
                if(data[2].status) {

                    var auth = btoa(encodeURI(encodeURIComponent(data[2].auth)));
                    $.cookie('auth', auth, { expires: 365, path: '/', domain: window.domain_in, secure: true });
                    /*location.reload();*/
                    window.location.href=data[2].url;

                } else {
                    window.NOTIFFICATIONS.open_wrong_password();
                    window.LOGIN.layers.new_account.password.val('');
                    window.LOGIN.layers.new_account.password_confirm.val('');
                    window.LOGIN.layers.new_account.submit_btn.prop('disabled', true);
                }
            break;
            case window.WS.ID.forgot_password:
                if(data[2] == 'success') {
                    window.NOTIFFICATIONS.open_recovery_emailsuccess();
                    setTimeout(function() {
                        location.reload();
                    }, 3000);
                } else if(data[2] == 'set_email') {
                     window.LOGIN.showOnePasswordForm();
                }

                if(typeof window.LOGIN.layers.resend_sms != 'undefined') {
                    window.LOGIN.layers.resend_sms.prop('disabled', false);
                }
            break;
            case window.WS.ID.general_info:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_general_info_success();
                }
            break;
            case window.WS.ID.change_password:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_change_password_success();
                }

                window.SETTINGS.layers.change_password.submit.prop('disabled', true);
                window.SETTINGS.layers.change_password.layer.removeClass('open');
            break;
            case window.WS.ID.logout:
                if(data[2] && data[2].status) {
                    $.removeCookie('auth');
                    location.reload();
                }
            break;
            case window.WS.ID.auth_edit:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_success_saved();
                    window.SETTINGS.findAuthCardName(window.SETTINGS.layers.auth.edit_card_window_pk.val()).html(window.SETTINGS.layers.auth.edit_card_window_name.val());
                    window.SETTINGS.layers.auth.edit_card_window_cross.click();
                } else {
                    window.NOTIFFICATIONS.open_error_saved();
                }
            break;
            case window.WS.ID.add_comment:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_success_saved();
                    window.WS.getChargerInfo(window.CHARGER.layers.add_comment.submit_btn.attr('data-id'));
                } else {
                    window.NOTIFFICATIONS.open_error_saved();
                }
                window.CHARGER.layers.add_comment.cross.click();
            break;
            case window.WS.ID.add_review:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_review_success();
                } else {
                    window.NOTIFFICATIONS.open_review_error();
                }

                if (window.CHARGER.layers.load.hasClass('active')) {
                    window.CHARGER.layers.load.removeClass('active');
                }
                window.CHARGER.layers.add_review.cross.click();
            break;
            case window.WS.ID.auth_delete:
                if(data[2]) {
                    window.NOTIFFICATIONS.open_success_delete();
                    window.SETTINGS.findAuthCard(window.SETTINGS.layers.auth.edit_card_window_pk.val()).addClass('hide');
                    window.SETTINGS.layers.auth.edit_card_window_cross.click();
                } else {
                    window.NOTIFFICATIONS.open_error_delete();
                }
            break;
            case window.WS.ID.book_connector:
                if(data[2].status) {
                    window.NOTIFFICATIONS.open_connector_book_success();
                    window.WS.getChargerInfo(data[2].charger);
                } else {
                    window.NOTIFFICATIONS.open_connector_book_error();
                }

                window.CHARGER.layers.book.cross.click();
            break;
            case window.WS.ID.full_transactions_history:
                window.BILLING.transactin_history_list(data[2]);
            break;
            case window.WS.ID.transaction_subscribe:
                if(data[2].status) {
                    window.BILLING.open_transaction_window(data[2], true);
                }
                if(window.BILLING.layers.load.hasClass('active')) {
                    window.BILLING.layers.load.removeClass('active');
                }
            break;
            case window.WS.ID.start_transaction:
            case window.WS.ID.stop_transaction:
                switch (data[2].status) {
                    case 'send_success':
                        window.NOTIFFICATIONS.open_send_to_charger_success();
                    break;
                    case 'send_error':
                        window.NOTIFFICATIONS.open_send_to_charger_error();
                    break;
                }

                if (window.CHARGER.layers.load.hasClass('active')) {
                    window.CHARGER.layers.load.removeClass('active');
                }
            break;
            case window.WS.ID.book_connector_tariff:
                if (data[2].status) {
                    window.CHARGER.update_book_data(data[2]);
                }
            break;
            case "auth":
                window.WS.auth = data[2].status;

                if(data[2].transactions_active != false) {
                    window.BILLING.layers.active_transaction_window.mab_btn.attr('data-pk', data[2].transactions_active.id);
                    window.BILLING.layers.active_transaction_window.mab_btn.attr('data-count', data[2].transactions_active.active_transactions.length);

                    window.BILLING.update_active_transactions(data[2].transactions_active.active_transactions);

                    if(data[2].transactions_active.soc > 0) {
                        window.BILLING.layers.active_transaction_window.mab_btn.find('span').html(data[2].transactions_active.soc +'%');
                    } else {
                        window.BILLING.layers.active_transaction_window.mab_btn.find('span').html('');
                    }

                    if(!window.BILLING.layers.active_transaction_window.mab_btn.hasClass('active')) {
                        window.BILLING.layers.active_transaction_window.mab_btn.addClass('active');
                    }
                } else {
                    if(window.BILLING.layers.active_transaction_window.mab_btn.hasClass('active')) {
                        window.BILLING.layers.active_transaction_window.mab_btn.removeClass('active');
                    }
                    if(window.BILLING.layers.active_transaction_window.window.hasClass('active')) {
                        window.BILLING.layers.active_transaction_window.cross.click();
                    }
                }

                if(window.check_get == false) {
                    var charger = parseFloat(window.getUrlParameter('charger'));
                    if(charger > 0) {
                        window.WS.getChargerInfo(charger);
                    }
                    window.check_get = true;
                }
            break;
            case "transaction:update":
                window.BILLING.open_transaction_window(data[2], false);
            break;
            case "transaction:update_soc":
                window.BILLING.update_transaction_soc(data[2]);
            break;
            case "transaction:stop":
                window.BILLING.stop_transaction(data[2]);
                window.NOTIFFICATIONS.layers.send_to_charger_success.cross.click();
                window.NOTIFFICATIONS.layers.send_to_charger_error.cross.click();
            break;
            case "transaction:start":
                window.BILLING.start_transaction(data[2]);
                window.NOTIFFICATIONS.layers.send_to_charger_success.cross.click();
                window.NOTIFFICATIONS.layers.send_to_charger_error.cross.click();
            break;
            case "balance:update":
                window.BILLING.layers.balance_value.html(data[2]['balance']);
            break;
            case "markers:update":
                window.WS.getMapChargers();
            break;
        }
    },

    wsOpen: async (event) => {
        if(window.WS.reconnectTimerID != false) {
            clearInterval(window.WS.reconnectTimerID);
            window.WS.reconnectTimerID = false;
        }

        window.WS.no_connected_status(false);
        window.NOTIFFICATIONS.close_server_no_connected();

        var message = JSON.stringify([
            14,
            window.MAKE_STR_RAND(25),
            "source",
            {
                "source": window.ws_source
            }
        ]);

        message = btoa(encodeURI(encodeURIComponent(message)));
        window.WS.socket.send(message);
    },

    wsClose: async (event) => {
        window.WS.reconnectTimerID = setInterval(async () => {
            if(window.WS.socket.isConnected()) {
                clearInterval(window.WS.reconnectTimerID);
                window.WS.reconnectTimerID = false;
            } else {
                window.WS.socket.connect();
                window.WS.reconnectCount += 1;
                if(window.WS.reconnectCount >= 10) {
                    window.location.reload();
                }
            }
        }, 2000);

        window.WS.no_connected_status(true);
    },

    getMapChargers: async () => {

        if(window.WS.socket.isConnected()) {
            var filter = $.cookie('filter');


            window.WS.ID.getMapChargers = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.getMapChargers,
                "getMapChargers",
                {
                    "filter": filter
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();

            setTimeout(function () {
                window.WS.getMapChargers();
            }, 1500);
        }
    },

    makeSearch: async (query) => {
        if(window.WS.socket.isConnected()) {
            if (query != '') {
                window.SEARCH.activeLoad();

                window.WS.ID.search = window.MAKE_STR_RAND(25);
                var message = JSON.stringify([
                    14,
                    window.WS.ID.search,
                    "search",
                    {
                        "query": query
                    }
                ]);

                message = btoa(encodeURI(encodeURIComponent(message)));
                window.WS.socket.send(message);
            }
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();

            setTimeout(function () {
                window.WS.makeSearch(query);
            }, 1500);
        }
    },

    getChargerInfo: async (charger_id) => {
        if(window.WS.socket.isConnected()) {
            var filter = $.cookie('filter');


            window.WS.ID.getChargerInfo = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.getChargerInfo,
                "getChargerInfo",
                {
                    "id": charger_id
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();

            setTimeout(function () {
                window.WS.getChargerInfo();
            }, 1500);
        }
    },

    login: {
        step1: async (phone, referral, utm_source) => {
            if(window.WS.socket.isConnected()) {
                window.WS.ID.loginPart1 = window.MAKE_STR_RAND(25);
                var message = JSON.stringify([
                    14,
                    window.WS.ID.loginPart1,
                    "login.step1",
                    {
                        "phone": phone,
                        "referral": referral,
                        "utm_source": utm_source
                    }
                ]);

                message = btoa(encodeURI(encodeURIComponent(message)));
                window.WS.socket.send(message);
            } else {
                window.NOTIFFICATIONS.open_server_no_connected();
            }
        },

        loginPassword: async (phone, password) => {
            if(window.WS.socket.isConnected()) {
                window.WS.ID.loginPassword = window.MAKE_STR_RAND(25);
                var message = JSON.stringify([
                    14,
                    window.WS.ID.loginPassword,
                    "login.password",
                    {
                        "phone": phone,
                        "password": password
                    }
                ]);

                message = btoa(encodeURI(encodeURIComponent(message)));
                window.WS.socket.send(message);
            } else {
                window.NOTIFFICATIONS.open_server_no_connected();
            }
        }
    },

    forgot_password: async (phone) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.forgot_password = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.forgot_password,
                "login.forgot_password",
                {
                    "phone": phone
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {

            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    login_one_password: async (email, phone) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.login_one_password = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.login_one_password,
                "login.login_one_password",
                {
                    "email": email,
                    "phone": phone
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {

            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    login_new_account_password: async (phone, code, password, password_confirm) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.login_new_account_password = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.login_new_account_password,
                "login.login_new_account_password",
                {
                    "phone": phone,
                    "code": code,
                    "password": password,
                    "password_confirm": password_confirm
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {

            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    general_info_form: async (name, email, notiffication_sms, notiffication_email) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.general_info = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.general_info,
                "generail_info",
                {
                    "name": name,
                    "email": email,
                    "notiffication_sms": notiffication_sms,
                    "notiffication_email": notiffication_email
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    change_password: async (passsword_old, passsword_new, passsword_new_confirm) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.change_password = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.change_password,
                "auth.password:change",
                {
                    "password_old": passsword_old,
                    "password_new": passsword_new,
                    "password_new_confirm": passsword_new_confirm
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    logout: async () => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.logout = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.logout,
                "logout",
                {
                    "logout": true
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    send_auth_edit: async (pk, name) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.auth_edit = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.auth_edit,
                "auth.edit",
                {
                    "pk": pk,
                    "name": name
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    send_auth_delete: async (pk) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.auth_delete = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.auth_delete,
                "auth.delete",
                {
                    "pk": pk,
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    full_transactions_history: async (date_from, date_to) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.full_transactions_history = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.full_transactions_history,
                "transactions.history",
                {
                    "from": date_from,
                    "to": date_to,
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    no_connected_status: async (status) => {
        if(status) {
            if(!window.WS.layers.no_connected_btn.hasClass('active')) {
                window.WS.layers.no_connected_btn.addClass('active');
            }
        } else {
            if(window.WS.layers.no_connected_btn.hasClass('active')) {
                window.WS.layers.no_connected_btn.removeClass('active');
            }
        }
    },

    transaction_subscribe: async (id) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.transaction_subscribe = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.transaction_subscribe,
                "transaction.subsctibe",
                {
                    "id": id
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    transaction_unsubscribe: async (id) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.transaction_unsubscribe = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.transaction_unsubscribe,
                "transaction.unsubsctibe",
                {
                    "id": id
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    skip_min_balance: async () => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.skip_min_balance = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.skip_min_balance,
                "user.skip_min_balance",
                {
                    "status": true
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    start_transaction: async (charger_pk, connector_pk) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.start_transaction = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.start_transaction,
                "transaction.start",
                {
                    "charger": charger_pk,
                    "connector": connector_pk
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    stop_transaction: async (transaction_id) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.stop_transaction = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.stop_transaction,
                "transaction.stop",
                {
                    "transaction": transaction_id
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    add_comment: async (rating, comment, charger) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.add_comment = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.add_comment,
                "comment.add",
                {
                    "rating": rating,
                    "comment": comment,
                    "charger": charger
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    add_review: async (rating, comment, transaction) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.add_review = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.add_review,
                "transaction.review.add",
                {
                    "rating": rating,
                    "comment": comment,
                    "transaction": transaction
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    book_connector_tariff: async (connector_pk) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.book_connector_tariff = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.book_connector_tariff,
                "connector.book.tariff",
                {
                    "connector_pk": connector_pk
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    book_connector: async (connector_pk, type) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.book_connector = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.book_connector,
                "connector.book",
                {
                    "connector_pk": connector_pk,
                    "type": type
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    delete_bank_card: async (card_pk) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.delete_bank_card = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.delete_bank_card,
                "bank_card.delete",
                {
                    "pk": card_pk
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    },

    default_bank_card: async (card_pk) => {
        if(window.WS.socket.isConnected()) {
            window.WS.ID.default_bank_card = window.MAKE_STR_RAND(25);
            var message = JSON.stringify([
                14,
                window.WS.ID.default_bank_card,
                "bank_card.default",
                {
                    "pk": card_pk
                }
            ]);

            message = btoa(encodeURI(encodeURIComponent(message)));
            window.WS.socket.send(message);
        } else {
            window.NOTIFFICATIONS.open_server_no_connected();
        }
    }

};
window.WS.init();


window.addEventListener("beforeunload", function (e) {
    window.WS.socket.close();
});
